// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'c0648c29-21f9-44b8-a962-b1d7dfb7f96d',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Island',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'BEACH VIEW',
        atlas: 'diorama_1',
        reward: {
          'Coin': 100,
          'BoosterRedraw': 1,
        }
      }
    },
    {
      id: '8c17f8b8-ec86-4519-95b1-16c8fa4112bb',
      type: 'Sprite',
      name: 'houseShadow',
      className: '',
      x: -12,
      y: -385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_House_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '281fd01e-7b04-4ccd-8e62-8e6855a98310',
      type: 'Sprite',
      name: 'house',
      className: '',
      x: -22,
      y: -389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_House',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 80,
        order: 1
      }
    },
    {
      id: '3346b159-06e6-468c-9421-f3b8f5bf831d',
      type: 'Sprite',
      name: 'windmillShadow',
      className: '',
      x: 87,
      y: -356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Windmill_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'e567a055-4b96-4f0f-b9bc-e672b6961b4e',
      type: 'Sprite',
      name: 'windmill',
      className: '',
      x: 165,
      y: -324,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Windmill',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 400,
        order: 3
      }
    },
    {
      id: '58803c62-b25a-49c3-a232-7dd1c6559a09',
      type: 'Sprite',
      name: 'lighthouseShadow',
      className: '',
      x: -164,
      y: -202,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Lighthouse_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ac497c8f-dfc0-4ac7-8e06-b49005e1cb0c',
      type: 'Sprite',
      name: 'lighthouse',
      className: '',
      x: -157,
      y: -321,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Lighthouse',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 200,
        order: 2
      }
    },
    {
      id: '823e4083-c845-4420-9414-bd2bac0e025b',
      type: 'Sprite',
      name: 'pierShadow',
      className: '',
      x: -71,
      y: -136,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Pier_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '02d54baf-ee27-4210-b310-e5da781b3016',
      type: 'Sprite',
      name: 'pier',
      className: '',
      x: -64,
      y: -147,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Pier',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 650,
        order: 4
      }
    },
    {
      id: '1917af34-f226-4692-a87e-2b24a8258533',
      type: 'Sprite',
      name: 'yachtShadow',
      className: '',
      x: 72,
      y: -205,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Yacht_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '299873f0-783a-4da9-a1fe-f21e4950ef6a',
      type: 'Sprite',
      name: 'yacht',
      className: '',
      x: 88,
      y: -231,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_1_Yacht',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 925,
        order: 5
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_1 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  houseShadow!: Sprite;
  house!: Sprite & { data: typeof raw['list'][3]['data'] };
  windmillShadow!: Sprite;
  windmill!: Sprite & { data: typeof raw['list'][5]['data'] };
  lighthouseShadow!: Sprite;
  lighthouse!: Sprite & { data: typeof raw['list'][7]['data'] };
  pierShadow!: Sprite;
  pier!: Sprite & { data: typeof raw['list'][9]['data'] };
  yachtShadow!: Sprite;
  yacht!: Sprite & { data: typeof raw['list'][11]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
